export * from "./mock";
export * from "./profile";
export * from "./upload";
export * from "./social-links";
export * from "./partners";

export const CREDIT_PRICE = 1000; // 1000 VND per credit
export const BRING_FRIEND_PRICE = 0.2; // 20% of the total ticket price per friend
export const SERVICE_FEE_PRICE = 0.01; // 0.5% of the total ticket

export const FORMAT_CREDIT_MAX_DECIMAL = 2; // 2 decimal places for credit

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MAX_CREDIT_PER_TX = 10_000; // ~ 10M vnd
export const MIN_CREDIT_PER_TX = 50; // ~ 50K vnd

export const CONTACT_EMAIL = "hello@garther.app";
export const SUPPORT_EMAIL = "support@garther.app";
